import React from 'react';
import { isHtmlContent, sanitizeHtml } from '../../utils/richText';

export default function RichHtmlContent({ content, className = '', as: Tag = 'div' }) {
  if (!content) return null;

  if (isHtmlContent(content)) {
    return (
      <Tag
        className={`gfi-rich-content ${className}`}
        dangerouslySetInnerHTML={{ __html: sanitizeHtml(content) }}
      />
    );
  }

  return (
    <Tag className={`whitespace-pre-wrap ${className}`}>
      {content}
    </Tag>
  );
}
